import React from "react";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

const CreatorSwitchButton = ({OnText, isOn, onClick, tooltipText = null, compact = false}) => {
    // Define the switch element to be reused
    const switchElement = (
        <div className="d-flex flex-row cursor-pointer" onClick={onClick}>
            <label className={`col-form-label ${compact ? 'py-0 pt-1' : ''} me-3 cursor-pointer`}>{OnText}</label>
            <span
                className="form-check form-check-custom form-check-solid form-check-success form-switch cursor-pointer">
        <label className="cursor-pointer">
          {" "}
            <input
                readOnly={true}
                checked={isOn}
                type="checkbox"
                name="use_separate_text"
                className="form-check-input w-40px h-25px cursor-pointer"
                id="id_use_separate_text"
            />
          <span></span>
        </label>
      </span>
        </div>
    );

    return (
        <div id="separateTextFieldsToggle" className="cursor-pointer">
            {tooltipText ? (
                <OverlayTrigger
                    delay={{show: 700, hide: 300}}
                    placement="right" // You can change the placement as needed
                    overlay={
                        <Tooltip>
                            <span style={{display: "block", textAlign: "left"}}
                                  className={"text-muted"}>{tooltipText}</span>
                        </Tooltip>
                    }
                >
                    {switchElement}
                </OverlayTrigger>
            ) : (
                switchElement
            )}
        </div>
    );
};

export default CreatorSwitchButton;
